jQuery(document).ready(function ($) {
  // Wrest Point Ninja Form IDs
  const NINJA_FORMS_CONTACT_PAGE = "3";
  const NINJA_FORMS_NEWSLETTER = "999";

  // Revinate public api token
  const REVINATE_TOKEN = "5c82d897-96fc-411e-b216-2e89f2d97aea";

  /**
   * Get the host of this script. The host will be used for posting the data.
   */
  var getHost = function () {
    return "contact-api.inguest.com";
  };

  function getFieldByCustomName(responseWrapper, customName) {
    // Check if responseWrapper exists and has the expected structure
    if (
      !responseWrapper ||
      !responseWrapper.response ||
      !responseWrapper.response.data ||
      !responseWrapper.response.data.fields
    ) {
      //  console.error("Invalid response structure:", responseWrapper);
      return null;
    }

    const fields = responseWrapper.response.data.fields;
    for (const fieldKey in fields) {
      if (fields.hasOwnProperty(fieldKey)) {
        const field = fields[fieldKey];
        if (field && field.custom_name_attribute === customName) {
          return field;
        }
      }
    }
    return null; // Return null if no matching field is found
  }
  function getFormData(form, token, response) {
    var data = { tokens: [token], contacts: [{}] };
    var contact = data.contacts[0];

    $(form)
      .find("input, select, textarea")
      .each(function () {
        var $field = $(this);
        var name = $field.attr("name");
        var value = $field.val();

        switch (name) {
          case "firstName":
            const firstNameField = getFieldByCustomName(response, "firstName");
            contact.firstName = firstNameField.value;
            break;
          case "lastName":
            const lastNameField = getFieldByCustomName(response, "lastName");
            contact.lastName = lastNameField.value;
            break;
          case "email":
            contact.email = value;
            if (contact.email === "") {
              const emailField = getFieldByCustomName(response, "email");
              contact.email = emailField.value;
            }
            break;
          // Add more cases here for other fields you want to capture
        }
      });

    // Combine first and last name into a single name field
    if (contact.firstName || contact.lastName) {
      contact.name = (
        (contact.firstName || "") +
        " " +
        (contact.lastName || "")
      ).trim();
    }

    return data;
  }

  function submitContact(postData) {
    var url = "//" + getHost() + "/api/add-contacts-to-lists";
    $.ajax({
      url: url,
      type: "POST",
      data: JSON.stringify(postData),
      contentType: "text/plain",
      success: function (response) {
        //console.log("*** CONTACT SUBMITTED ***", response);
      },
      error: function (xhr, status, error) {
        //console.error("*** CONTACT SUBMISSION ERROR ***", status, error);
        //console.log(xhr.responseText);
      },
    });
  }

  function createRevinateContact(form_id, response) {
    var formSelector = `#nf-form-${form_id}-cont form`;
    var formElement = $(formSelector)[0];

    if (!formElement) {
      // console.error("Form not found:", formSelector);
      return;
    }

    var data = getFormData(formElement, REVINATE_TOKEN, response);

    if (!data.contacts[0].email) {
      //console.error("Email is required");
      return;
    }

    submitContact(data);
  }

  function handleFormSubmission(form_id, response) {
    //console.log("Handling form submission for form ID:", form_id);

    if (
      form_id === NINJA_FORMS_CONTACT_PAGE ||
      form_id === NINJA_FORMS_NEWSLETTER
    ) {
      createRevinateContact(form_id, response);
    } else {
      //console.log("Form submitted, but not one we're tracking:", form_id);
    }
  }

  // Use a Set to keep track of processed form submissions
  let processedForms = new Set();

  $(document).on("nfFormSubmitResponse", function (event, response) {
    //console.log("nfFormSubmitResponse triggered", response);

    if (response && typeof response === "object" && response.id) {
      const formId = response.id;

      // Check if this form has already been processed
      if (processedForms.has(formId)) {
        //console.log("Form already processed:", formId);
        return;
      }

      // Add the form ID to the set of processed forms
      processedForms.add(formId);

      handleFormSubmission(formId, response);

      // Remove the form ID from the set after a delay
      setTimeout(() => {
        processedForms.delete(formId);
      }, 5000); // 5 seconds delay
    } else {
      //console.error("Invalid response structure:", response);
    }
  });

  //console.log("Revinate contact script initialized");
});
